import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${queryFilter.sort},${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/atendimento/especialidades${queryUrl}`)
  },
  insert(data) {
    return axios.post('/atendimento/especialidades', data)
  },
  edit(data) {
    return axios.put(`/atendimento/especialidades/${data.id}`, data)
  },
  delete(id) {
    return axios.delete(`/atendimento/especialidades/${id}`)
  },
  loadAll() {
    return axios.get('/atendimento/especialidades/lista')
  },
}
